import type { ComponentPropsWithoutRef } from "react";

import { cn } from "@/lib/utils";

type AuthenticationFormTransitionProps = ComponentPropsWithoutRef<"div">;

type EnterAnimation = "slideInRight" | "zoomIn";

type Props = AuthenticationFormTransitionProps & {
  isExiting?: boolean;
  enterAnimation?: EnterAnimation;
};

const enterAnimationClasses: Record<EnterAnimation, string> = {
  slideInRight: "animate__slideInRight",
  zoomIn: "animate__zoomIn",
};

export function AuthenticationFormTransition({
  isExiting = false,
  enterAnimation = "zoomIn",
  className,
  ...props
}: Props) {
  return (
    <div
      className={cn(
        "animate__animated animate__fast",
        !isExiting && "motion-reduce:animate-none",
        isExiting ? "animate__slideOutLeft" : enterAnimationClasses[enterAnimation],
        className,
      )}
      {...props}
    />
  );
}
